import { getQueryInitialState } from '../../features/query/query-state.js';
import { getSearchInitialState } from '../../features/search/search-state.js';
import { SearchAnalyticsProvider, } from './search-analytics.js';
export class InstantResultsAnalyticsProvider extends SearchAnalyticsProvider {
    getState;
    constructor(getState) {
        super(getState);
        this.getState = getState;
    }
    get activeInstantResultQuery() {
        const state = this.getState().instantResults;
        for (const id in state) {
            for (const query in state[id].cache) {
                if (state[id].cache[query].isActive) {
                    return state[id].q;
                }
            }
        }
        return null;
    }
    get activeInstantResultCache() {
        const state = this.getState().instantResults;
        for (const id in state) {
            for (const query in state[id].cache) {
                if (state[id].cache[query].isActive) {
                    return state[id].cache[query];
                }
            }
        }
        return null;
    }
    get results() {
        return this.activeInstantResultCache?.results;
    }
    get queryText() {
        return this.activeInstantResultQuery ?? getQueryInitialState().q;
    }
    get responseTime() {
        return (this.activeInstantResultCache?.duration ??
            getSearchInitialState().duration);
    }
    get numberOfResults() {
        return (this.activeInstantResultCache?.totalCountFiltered ??
            getSearchInitialState().response.totalCountFiltered);
    }
    getSearchUID() {
        const searchUid = this.activeInstantResultCache?.searchUid;
        return searchUid || super.getSearchUID();
    }
}
